import React from 'react';
import xmBank from '@/assets/xiamen.png';
import ssBank from '@/assets/subank.png';
import lhBank from '@/assets/lanhaibank.png';
import xsBank from '@/assets/xishangbank.png';
import ylBank from '@/assets/yilianbank.png';
import bxBank from '@/assets/baixinbank.png';
import xwBank from '@/assets/xinwang.png';

function ThirdPayBankIcon(props) {
  const {
    tag
  } = props;

  switch (tag) {
    case '厦门国际银行':
      return /*#__PURE__*/React.createElement("img", {
        src: xmBank,
        style: {
          height: 20,
          width: 80
        }
      });

    case '苏商银行':
      return /*#__PURE__*/React.createElement("img", {
        src: ssBank,
        style: {
          height: 20,
          width: 80
        }
      });

    case '新网银行':
      return /*#__PURE__*/React.createElement("img", {
        src: xwBank,
        style: {
          height: 12,
          width: 80
        }
      });

    case '蓝海银行':
      return /*#__PURE__*/React.createElement("img", {
        src: lhBank,
        style: {
          height: 20,
          width: 80
        }
      });

    case '百信银行':
      return /*#__PURE__*/React.createElement("img", {
        src: bxBank,
        style: {
          height: 24,
          width: 80
        }
      });

    case '无锡锡商银行':
      return /*#__PURE__*/React.createElement("img", {
        src: xsBank,
        style: {
          height: 18,
          width: 80
        }
      });

    case '吉林亿联银行':
      return /*#__PURE__*/React.createElement("img", {
        src: ylBank,
        style: {
          height: 20,
          width: 80
        }
      });

    default:
      return tag;
  }
}

export default ThirdPayBankIcon;